/**
 * =============================================================================
 * MAIN - Ponto de Entrada da Aplicação
 * =============================================================================
 *
 * Este é o ficheiro principal que inicializa a aplicação React.
 * - Importa o React StrictMode para deteção de problemas
 * - Renderiza o componente App na raiz do DOM
 * - Importa os estilos CSS globais
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { MaintenanceCheck } from "./components/MaintenanceCheck";

// Importação dos estilos CSS globais (Tailwind + customizações)
import "./index.css";

// Criação da raiz React e renderização da aplicação
// O "!" garante que o elemento existe (non-null assertion)
const rootElement = document.getElementById("root")!;
createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <MaintenanceCheck>
        <App />
      </MaintenanceCheck>
    </HelmetProvider>
  </StrictMode>
);
